import type { HistoricalSource } from './sources';

export const CARE_SOURCES = {
  gasthuisLife: {
    url: 'https://www.amsterdam.nl/stadsarchief/canon/venster/6/',
    title: '1492 Gasthuis',
    publisher: 'Stadsarchief Amsterdam',
    note: {
      en: 'The Amsterdam canon describes a community providing meals, shelter and care, with a bakery, brewery and women doing much of its daily work. Its medical case from 1553 and later illustrations are dated evidence, not an exact 1538 interior.',
      nl: 'De Amsterdamse canon beschrijft een gemeenschap met eten, onderdak en zorg, een bakkerij, brouwerij en vrouwen die veel dagelijks werk verrichten. Het medische geval uit 1553 en de latere afbeeldingen zijn gedateerde bronnen, geen exact interieur uit 1538.',
    },
  },
  gasthuis: {
    url: 'https://www.amsterdam.nl/stadsarchief/stukken/verdwenen-amsterdam/sint-pieters/',
    title: 'Sint Pieters Gasthuis',
    publisher: 'Stadsarchief Amsterdam',
    note: {
      en: 'The old Sint Pietersgasthuis stood on the Nes. It moved into the former Nonnen convents in 1578. The illustrated 1627–1628 complex belongs to that later site, not our 1538 city.',
      nl: 'Het oude Sint Pietersgasthuis stond aan de Nes. In 1578 verhuisde het naar de voormalige Nonnenkloosters. Het afgebeelde complex uit 1627–1628 hoort bij die latere locatie, niet bij onze stad van 1538.',
    },
  },
  gasthuisAccounts: {
    url: 'https://www.amsterdamsegasthuizen.nl/',
    title: 'Amsterdamse Gasthuizen: de gasthuisarchieven',
    publisher: 'Stichting Middeleeuwse Archieven Amsterdam',
    note: {
      en: 'This archive project explains the Nes gasthuis and chapel. Its household stories use accounts from 1550–1559, later than our city. Furniture, chores and characters here are reconstructions; those accounts do not fix their positions in 1538.',
      nl: 'Dit archiefproject beschrijft het gasthuis en de kapel aan de Nes. De huishoudelijke verhalen gebruiken rekeningen uit 1550–1559, later dan onze stad. Meubels, werkzaamheden en personages hier zijn reconstructies; die rekeningen bepalen hun plek in 1538 niet.',
    },
  },
  gasthuisStaff: {
    url: 'https://scripties.uba.uva.nl/download?fid=c13496276',
    title: 'Vrouwen, gender en agency in het Sint-Pietersgasthuis (1470–1560)',
    publisher: 'Universiteit van Amsterdam · Annick Gossen, 2025',
    note: {
      en: 'Archival research identifies paid lay gasthuismoeders and maids, and residents who purchased board and lodging. The attendants in our city represent everyday work; their names and movements are not recorded biographies.',
      nl: 'Archiefonderzoek beschrijft betaalde gasthuismoeders en meiden die geen kloosterlingen waren, en bewoners die kost en inwoning kochten. Onze medewerkers verbeelden dagelijks werk; hun namen en bewegingen zijn geen gedocumenteerde levensverhalen.',
    },
  },
  leprozen: {
    url: 'https://www.amsterdam.nl/nieuws/achtergrond/lepra-grootste-angst/',
    title: 'Lepra, de grootste angst voor iedere Amsterdammer',
    publisher: 'Gemeente Amsterdam',
    note: {
      en: 'Amsterdam had a separate Leprozenhuis, initially outside the city. Fear and stigma shaped isolation, although leprosy is not easily transmitted. The article also describes later centuries; those later images do not document its 1538 interior.',
      nl: 'Amsterdam had een afzonderlijk Leprozenhuis, aanvankelijk buiten de stad. Angst en uitsluiting bepaalden de afzondering, hoewel lepra niet gemakkelijk wordt overgedragen. Het artikel beschrijft ook latere eeuwen; die afbeeldingen tonen geen interieur uit 1538.',
    },
  },
} as const satisfies Readonly<Record<string, HistoricalSource>>;
